import { useSyncExternalStore } from 'react'

/**
 * Reactive dark mode detection — subscribes to class changes on <html>.
 * Returns `true` when `document.documentElement` has the `dark` class.
 */
export function useIsDarkMode() {
  return useSyncExternalStore(
    (callback) => {
      const observer = new MutationObserver(callback)
      observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })
      return () => observer.disconnect()
    },
    () => document.documentElement.classList.contains('dark'),
    () => false, // SSR fallback
  )
}
